import { render, staticRenderFns } from "./confirmation_data.vue?vue&type=template&id=542577d2"
import script from "./confirmation_data.vue?vue&type=script&lang=js"
export * from "./confirmation_data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports